module.exports = __webpack_public_path__ + "static/media/007-half-shadow.e3d8c267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CareIcons/007-half-shadow.png
// module id = 643
// module chunks = 0